<template>
    <div class="bg-light rounded border">
        <div class="card p-3 product-content-card">
            <div class="position-relative mb-4 d-flex justify-content-center">
                <div class="position-absolute top-0 start-0 mt-3 ms-n4">
                    <like-btn class="border bg-white rounded-pill py-1 px-2 fw-bold" :slug="product.slug" :liked="product.liked" :likeCount="product.likeCount"/>
                </div>

                <!--                <div-->
                <!--                    class="position-absolute top-100 start-50 translate-middle border bg-white rounded-pill py-1 px-2 fw-bold">-->
                <!--                    <div class="hstack gap-1">-->
                <!--                        ۰۸:۲۰:۰۹-->

                <!--                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"-->
                <!--                             xmlns="http://www.w3.org/2000/svg">-->
                <!--                            <path-->
                <!--                                d="M3.35288 15.0496L4.08306 14.8783L3.35288 15.0496ZM3.35288 8.95043L4.08306 9.12171L3.35288 8.95043ZM20.6471 8.95044L19.9169 9.12171L20.6471 8.95044ZM20.6471 15.0496L19.9169 14.8783L20.6471 15.0496ZM15.0496 20.6471L15.2208 21.3773L15.0496 20.6471ZM8.95044 20.6471L9.12171 19.9169L8.95044 20.6471ZM8.95043 3.35288L9.12171 4.08306L8.95043 3.35288ZM15.0496 3.35288L15.2208 2.6227L15.0496 3.35288ZM4.08306 14.8783C3.63898 12.9851 3.63898 11.0149 4.08306 9.12171L2.6227 8.77915C2.12577 10.8976 2.12577 13.1024 2.6227 15.2209L4.08306 14.8783ZM19.9169 9.12171C20.361 11.0149 20.361 12.9851 19.9169 14.8783L21.3773 15.2208C21.8742 13.1024 21.8742 10.8976 21.3773 8.77916L19.9169 9.12171ZM14.8783 19.9169C12.9851 20.361 11.0149 20.361 9.12171 19.9169L8.77916 21.3773C10.8976 21.8742 13.1024 21.8742 15.2208 21.3773L14.8783 19.9169ZM9.12171 4.08306C11.0149 3.63898 12.9851 3.63898 14.8783 4.08306L15.2208 2.6227C13.1024 2.12577 10.8976 2.12577 8.77916 2.6227L9.12171 4.08306ZM9.12171 19.9169C6.62161 19.3305 4.6695 17.3784 4.08306 14.8783L2.6227 15.2209C3.33924 18.2756 5.72442 20.6608 8.77916 21.3773L9.12171 19.9169ZM15.2208 21.3773C18.2756 20.6608 20.6608 18.2756 21.3773 15.2208L19.9169 14.8783C19.3305 17.3784 17.3784 19.3305 14.8783 19.9169L15.2208 21.3773ZM14.8783 4.08306C17.3784 4.6695 19.3305 6.62161 19.9169 9.12171L21.3773 8.77916C20.6608 5.72441 18.2756 3.33924 15.2208 2.6227L14.8783 4.08306ZM8.77916 2.6227C5.72441 3.33924 3.33924 5.72441 2.6227 8.77915L4.08306 9.12171C4.6695 6.6216 6.62161 4.6695 9.12171 4.08306L8.77916 2.6227Z"-->
                <!--                                fill="#212529"/>-->
                <!--                            <path-->
                <!--                                d="M14.0961 15.1328C14.4456 15.3551 14.9092 15.2521 15.1315 14.9026C15.3539 14.5531 15.2508 14.0896 14.9014 13.8672L14.0961 15.1328ZM11.6602 12.6939H10.9102C10.9102 12.9503 11.0412 13.189 11.2575 13.3267L11.6602 12.6939ZM12.4102 9C12.4102 8.58579 12.0744 8.25 11.6602 8.25C11.2459 8.25 10.9102 8.58579 10.9102 9H12.4102ZM14.9014 13.8672L12.0628 12.0611L11.2575 13.3267L14.0961 15.1328L14.9014 13.8672ZM12.4102 12.6939V9H10.9102V12.6939H12.4102Z"-->
                <!--                                fill="#212529"/>-->
                <!--                        </svg>-->

                <!--                    </div>-->
                <!--                </div>-->
                <a v-if="product.image" :href="product.url">
                    <img class="rounded img-fluid" :src="product.image.url['520x520']" :alt="product.title">
                </a>
            </div>

            <h5 class="card-title fw-bold"><a :href="product.url">{{ product.title }}</a></h5>
        </div>
        <div class="px-3 py-2">
            <div class="hstack gap-2">
                <!--                <div class="text-dark">۱۳۰٫۰۰۰</div>-->
                <!--                <div class="vr"></div>-->
                <div v-if="product.states" class="fw-bold">
                    {{ toFaNum(Math.min(...product.states.map(state => state.price))) }}
                    تومان
                </div>
                <div class="ms-auto">
                    <a :href="product.url"
                       class="btn btn-primary bg-gradient-primary p-2 rounded-2 border-0">

                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
                                stroke="white" stroke-width="1.5"/>
                            <path d="M14.5 12H9.5M12 14.5L12 9.5" stroke="white" stroke-width="1.5"
                                  stroke-linecap="round"/>
                        </svg>

                    </a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        product: Object,
    }
}
</script>

<style scoped>

</style>
